import { Tooltip } from 'react-tooltip'
import { NumberBoxProps } from 'Types/Presentation/Components/Statistics/NumberBox'

// import { formatNumberAbbreviation } from 'Utils/formatNumberAbbreviation'
import formatNumberCommas from 'Utils/formatNumberCommas'

const NumberBox: React.FC<NumberBoxProps> = ({
	actionTitle,
	action,
	toolTip,
	unitTooltip,
	name,
	title,
	valueChangePercentage,
	value,
	unit,
	hideTrend,
}) => {
	const parseValue = parseFloat(String(valueChangePercentage))

	return (
		<div
			className="card statistics-number-box h-100 border border-kumopack-grey-200"
			id={`${name ?? ''} ${title ?? ''}`}>
			<div className="card-body px-4 py-4">
				<div className="d-flex flex-column justify-content-between px-0 h-100">
					{/* start:: Header */}
					<div className="row">
						<div className="col-8">
							<p className="fs-6 fw-bolder my-0" style={{ color: '#373634' }}>
								{title}
							</p>
						</div>
						{!hideTrend && (
							<div className="col-4">
								<p className="fs-9 fw-bold my-0 text-kumopack-base-black text-end">
									{`${valueChangePercentage ? (parseValue >= 0 ? '+' : '') : ''} ${
										valueChangePercentage ?? 0
									}%`}
									{valueChangePercentage &&
										(parseValue >= 0 ? (
											<img
												className="ms-2"
												src="/media/icons/kumopack/green-growth-indicator.png"
												alt="Value Change Percentage Up"
												width={16}
												height={16}
											/>
										) : (
											<img
												className="ms-2"
												src="/media/icons/kumopack/red-growth-indicator.png"
												alt="Value Change Percentage Up"
												width={16}
												height={16}
											/>
										))}
								</p>
								<p className="fs-9 my-0 text-end" style={{ color: '#98A2B3' }}>
									vs last week
								</p>
							</div>
						)}
					</div>
					{/* end:: Header */}

					{/* start:: View Report */}

					<div>
						{/* start:: Value */}
						<div className="row">
							<div className="col-12 cursor-pointer" id={`number-box-tooltip-${toolTip}`}>
								<p
									className={`fs-5x fs-lg-4x fs-xxl-3x my-0 d-inline-block fw-bolder ${
										parseValue >= 0 ? 'text-kumopack-secondary-700' : 'text-kumopack-error-400'
									}`}>
									{/* @ts-ignore */}
									{formatNumberCommas(value)}
								</p>
								<p className="fs-1 my-0 px-2 d-inline-block text-kumopack-grey-400">{unit}</p>

								{toolTip && (
									<Tooltip anchorSelect={`#number-box-tooltip-${toolTip}`} place="top">
										{/* @ts-ignore */}
										{formatNumberCommas(value)} {unitTooltip}
									</Tooltip>
								)}
							</div>

							{/* end:: Value */}
						</div>

						{actionTitle && <hr className="d-none d-lg-block" />}

						<div className="row py-0 d-none d-lg-block">
							<div className="col-12">
								<div
									className="d-flex flex-row align-items-center justify-content-end"
									style={{ columnGap: '12px' }}>
									{actionTitle && (
										<div
											className="fs-6 my-0 text-end text-kumopack-secondary-700 fw-bold"
											onClick={action}
											style={{
												cursor: 'pointer',
											}}>
											{actionTitle}
										</div>
									)}
								</div>
							</div>
						</div>
						{/* end:: View Report */}
					</div>
				</div>
			</div>
		</div>
	)
}

export default NumberBox
